export default {
  name: 'MInputFeedback',
  props: {
    id: {
      type: String,
      required: true,
    },
    state: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: true,
    },
  },
};
